(() => {
  const initQuantityControls = (root = document) => {
    root.querySelectorAll('[data-lance-quantity]').forEach((control) => {
      if (control.dataset.ready === 'true') return;
      const input = control.querySelector('input[type="number"]');
      if (!input) return;
      control.dataset.ready = 'true';
      control.querySelectorAll('button[data-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.step || 0);
          const step = Number(input.step || 1);
          const minimum = Number(input.min || 0);
          const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
          const current = Number(input.value || minimum);
          input.value = String(Math.min(maximum, Math.max(minimum, current + direction * step)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  const initAccountPanels = (root = document) => {
    root.querySelectorAll('[data-lance-panel-trigger]').forEach((trigger) => {
      if (trigger.dataset.ready === 'true') return;
      trigger.dataset.ready = 'true';
      trigger.addEventListener('click', () => {
        const target = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!target) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        target.hidden = expanded;
        if (!expanded) target.querySelector('input')?.focus();
      });
    });
  };

  const init = (root = document) => {
    initQuantityControls(root);
    initAccountPanels(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
